var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIotSensors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.772,
    height: 30.306,
    viewBox: "0 0 37.772 30.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689",
    transform: "translate(-44.514 -243.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2906",
    "data-name": "Path 2906",
    d: "M82.286,251.327c-.487.479-.976.956-1.46,1.439-.395.395-.783.8-1.178,1.2a22.952,22.952,0,0,0-32.48-.04l-2.654-2.654c.369-.346.737-.734,1.148-1.068.907-.735,1.808-1.484,2.763-2.152a24.959,24.959,0,0,1,5.476-2.867,26.711,26.711,0,0,1,4.845-1.336,27,27,0,0,1,5.2-.4,26.421,26.421,0,0,1,12.27,3.284,26.785,26.785,0,0,1,5.312,3.844l.755.707Z",
    fill: "#8b96ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2907",
    "data-name": "Path 2907",
    d: "M76.961,256.622l-2.653,2.637a15.43,15.43,0,0,0-21.839,0l-2.65-2.636A19.1,19.1,0,0,1,76.961,256.622Z",
    fill: "#8b96ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2908",
    "data-name": "Path 2908",
    d: "M55.163,261.906a11.592,11.592,0,0,1,16.468.017l-2.663,2.638a7.9,7.9,0,0,0-11.159,0Z",
    fill: "#8b96ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2909",
    "data-name": "Path 2909",
    d: "M63.1,273.251a6.615,6.615,0,0,1-.659-.164,2.9,2.9,0,0,1-1.987-2.275,2.86,2.86,0,0,1,1.152-3c.738-.554,6.751-11.973,9.7-17.626a.333.333,0,0,1,.615.248c-1.836,6.17-5.542,18.752-5.5,19.616A2.975,2.975,0,0,1,64,273.191l-.279.06Z",
    fill: "#8b96ab",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotSensors);
export default __webpack_public_path__ + "static/media/iotSensors.f4fb325b88b98142d63c9dfb3a7cb777.svg";
export { ForwardRef as ReactComponent };